import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useLocation } from "wouter";

export function MaterialsTab({ installationId }: { installationId: number }) {
    const [, setLocation] = useLocation();

    useEffect(() => {
        setLocation(`/installations/${installationId}/materials`);
    }, [installationId, setLocation]);

    return (
        <Card>
            <CardContent className="flex items-center gap-2 p-6 text-muted-foreground">
                <Loader2 className="h-4 w-4 animate-spin" />
                Abriendo gestión de materiales…
            </CardContent>
        </Card>
    );
}
